




































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { Spinner } from 'vue-image-spinner2';
import { Debounce } from 'vue-debounce-decorator';
import ProductGallery from '../components/ProductGallery.vue';

import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash';

@Component({
    name: 'prodelec-post-modal',
    components: {
        ProductGallery,
        Spinner,
    },
    computed: {
        formattedPrice() {
            return this.calculatePrice();
        },
        minStock() {
            return +this.calculateMinStock();
        },

        // ...mapState('prodelecPost', ['activeProdelecPostLoading', 'activeProdelecPost']),
        ...mapState('auth', ['currentUser']),
        ...mapState('webInventory', [
            'activeProduct',
            'activeProductLoading',
            'allProducts',
            'allCombos',
            'allProductsLoading',
            'productsPerPage',
            'productsPage',
            'productsTotal',
        ]),
        ...mapState('products', ['cacheProducts', 'cacheProductsLoading']),
        ...mapState('productBrands', ['allProductBrands']),
        ...mapState('productCategories', ['allProductCategories']),
        ...mapState('productSectors', ['allProductSectors']),
        ...mapState('productApplications', ['allProductApplications']),
    },
})
export default class ProdelecPostModal extends Vue {
    private currentUser!: any;
    private cacheProducts!: any;
    public allProducts!: any;
    public allCombos!: any;
    public activeProduct!: any;
    public activeProductLoading!: any;
    public allProductsLoading!: any;
    public productsPerPage!: any;
    public productsPage!: any;
    public productsTotal!: any;
    public productsPageTest!: any;
    public client!: any;
    private searchQuery: string = '';
    public disableEcommerce: boolean = true;
    public subtotal: string = '';
    public properties = {};

    canSee(roles: any) {
        return _.intersection(roles, [this.currentUser.role.name]).length > 0;
    }

    onSaveProdelecPost() {

        console.log('vas bien samuel');
        
        this.activeProductLoading = true;
        let product: any = {};
        let newWord = '';

        console.log('this activeProduct',this.activeProduct );
        console.log('combo_products',this.activeProduct.combo_products[0].clave_sat);
        
        

        this.activeProduct.stock_total = +this.calculateMinStock();
        this.activeProduct.price = this.calculatePrice();
        if (
            this.activeProduct.name !== '' &&
            this.activeProduct.combo_products.length > 0 &&
            this.activeProduct.price > 0 &&
            this.activeProduct.stock_total > 0 &&
            this.activeProduct.description !== '' &&
            this.activeProduct.gallery.length > 0 &&
            this.activeProduct.category &&
            this.activeProduct.brand
        ) {
            console.log('creating prodelec post');
            if (!this.activeProduct.id) {
                this.activeProduct.tall = this.activeProduct?.tall || 0;
                this.activeProduct.long = this.activeProduct?.long || 0;
                this.activeProduct.weight = this.activeProduct?.weight || 0;
                this.activeProduct.wide = this.activeProduct?.wide || 0;
                this.activeProduct.clave_sat = this.activeProduct?.combo_products[0].clave_sat || '0';

                this.activeProduct.id = this.generateRandomString(7);
                this.activeProduct.description = this.activeProduct.description.replace(/<[^>]*>/g, '');
                newWord = this.capitalizeFirstLetterOfEachWord(this.activeProduct.name);

                product = {
                    ...this.activeProduct,
                    name: newWord,
                    is_active: this.activeProduct.is_active != null ? this.activeProduct.is_active : false,
                    is_combo: true,
                    clave_sat: this.activeProduct?.combo_products[0].clave_sat,
                    price: this.calculatePrice(),
                };
            } else {
                console.log('updating prodelec post');
                this.activeProduct.description = this.activeProduct.description.replace(/<[^>]*>/g, '');
                newWord = this.capitalizeFirstLetterOfEachWord(this.activeProduct.name);

                product = {
                    ...this.activeProduct,
                    name: newWord,
                    is_combo: true,
                    clave_sat: this.activeProduct?.combo_products[0].clave_sat,
                    price: this.calculatePrice(),
                };
            }

            console.log('creating/updating prodelec post');

            console.log('producto a guardar', product)
            this.$store.dispatch('webInventory/postOne', {
                product,
                view: this,
            });
        } else {
            this.$bvToast.toast('Todos los campos son obligatorios excepto (Alto, Largo, Ancho, y Peso)', {
                title: `Campos obligatorios`,
                variant: 'info',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
            });
        }
    }

    calculateMinStock() {
        if (this.activeProduct.combo_products.length === 0) {
            return 0;
        }
        return this.activeProduct.combo_products.reduce((minStock, currentProduct) => {
            let currentStock = parseInt(currentProduct.stock, 10);
            let enteredQty = parseInt(currentProduct.qty, 10);
            if (enteredQty <= currentStock) {
                currentStock = parseInt((currentStock / enteredQty).toString());
            }

            return currentStock < +minStock ? currentStock : +minStock;
        }, this.activeProduct.combo_products[0].stock);
    }

    generateRandomString(length) {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let result = '';
        const charactersLength = characters.length;

        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }

        return result;
    }

    onAddItem(parent: any) {
        parent.combo_products.push({
            new: true,
        });
    }

    capitalizeFirstLetterOfEachWord(name: string): string {
        return name
            .split(' ')
            .map((word) => {
                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            })
            .join(' ');
    }

    onRemoveItem(parent: any, index: any, product: any) {
        parent.combo_products.splice(index, 1);
         this.removePropertiesFromActiveProduct(product);
        if (product.gallery) {
            let imgCoincidence = (element: any) => element.id == product.gallery[0].id;
            let indexRemove = this.activeProduct.gallery.findIndex(imgCoincidence);
            this.activeProduct.gallery.splice(indexRemove, 1);
        }

        if (this.activeProduct.description) {
            const productStringPattern = new RegExp(`<li>\\d+pz del producto ${product.id},</li>`, 'g');
            this.activeProduct.description = this.activeProduct.description.replace(productStringPattern, '');
        }
        if (!this.activeProduct.description.includes('<li>')) {
            this.activeProduct.description = '';
        }

    }

    @Watch('searchQuery')
    @Debounce(600)
    updateProductsList(search: string) {
        console.log('searching...');
        if (/\s/.test(this.searchQuery)) {
            //validation for one or many words
            const finalSentence = this.searchQuery.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
            this.searchQuery = finalSentence;
        } else {
            this.searchQuery = this.searchQuery.toUpperCase();
        }
        if (this.searchQuery.length > 1 && this.searchQuery.trim() != '') {
            this.$store.dispatch('products/cacheAll', { search, limit: 40 });
        }
    }

    calculateStockQty(event, stock, product) {
        let qtyInput = parseInt(event, 10);
        let stockProduct = parseInt(stock, 10);

        if (isNaN(qtyInput) || qtyInput <= 0) {
            this.$bvToast.toast('La cantidad debe ser mayor a 0', {
                title: 'Cantidad insuficiente',
                variant: 'info',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
            });
        } else if (qtyInput > stockProduct) {
            product.qty = '1';
            this.$bvToast.toast('La cantidad es mayor al stock disponible', {
                title: 'Stock insuficiente',
                variant: 'info',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
            });
        } else {
            this.activeProduct.stock_total = stock - qtyInput;

            if (product.qty !== qtyInput) {
                product.qty = qtyInput;
                this.createDescriptionDefault(product);
            }
        }
        this.calculatePrice();
    }

    calculatePrice() {
        if (this.activeProduct.name !== '') {
            let total = this.calculatePriceTotal(this.activeProduct.combo_products);
            return total.toFixed(2) || 0;
        } else {
            this.activeProduct.combo_products = [];
            return 0;
        }
    }

    calculatePriceTotal(products: any) {
        return products.reduce((total, product, index) => {
            if (product.price) {
                let qty = parseInt(this.activeProduct.combo_products[index].qty);
                return total + parseFloat(product.price) * qty;
            } else {
                return 0;
            }
        }, 0);
    }

    createDescriptionDefault(product: any | null) {
        if (!this.activeProduct.description) {
            this.activeProduct.description = 'Este combo incluye:<ul>';
        }

        const productStringPattern = new RegExp(`\\d+pz del producto ${product.id},`, 'g');

        if (productStringPattern.test(this.activeProduct.description)) {
            this.activeProduct.description = this.activeProduct.description.replace(
                productStringPattern,
                `${product.qty}pz del producto ${product.id},`
            );
        } else {
            this.activeProduct.description += `<li>${product.qty}pz del producto ${product.id},</li>`;
        }
    }

    calculateSubtotal(product) {
        return product.price * (product.qty || 0);
    }

    onSetItem(product: any, parent: any, index: number) {
        let stock = +product.stock;
        if (stock > 0) {
            const productIndex = parent.combo_products.findIndex((producto) => producto.id === product.id);
            const existingId = productIndex !== -1;

            if (existingId) {
                const qty = +parent.combo_products[productIndex].qty + 1;
                parent.combo_products.splice(index, 1);
                parent.combo_products[productIndex].qty = qty;
            } else {
                parent.combo_products.splice(index, 1);
                parent.combo_products.push({
                    new: false,
                    qty: 1,
                    ...product,
                });
            }
            // Actualiza la descripción después de agregar o modificar el producto
            let p = { ...product, qty: parent.combo_products[productIndex]?.qty || 1 };
            this.createDescriptionDefault(p);
            this.onSetProperty(p);

        } else {
            this.$bvToast.toast('No hay suficiente stock', {
                title: `Stock insuficiente`,
                variant: 'info',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
            });
            this.activeProduct.combo_products[index].label = '';
        }
    }

    getProductUrl(id: string) {
        // return `https://www.prodelec.mx/tienda?title=${id}&similar=true`; // redirect to prodelec.mx
        return `https://www.prodelec.app/#/products?search=${id}&page=1`; // redirect to www.prodelec.app
    }

    onRemoveImg(index: any) {
        this.activeProduct.gallery.splice(index, 1);
    }

    onFileChange(e: any) {
        if (e.target) {
            const files = e.target.files;
            files.forEach((file: any) => {
                let formData = new FormData();
                formData.append('image', file, file.name);
                this.activeProduct.gallery = [
                    ...this.activeProduct.gallery,
                    {
                        id: uuidv4(),
                        sort: null,
                        url: URL.createObjectURL(file),
                        origin: 'upload',
                        file: formData,
                        name: file.name,
                    },
                ];
            });
        } else {
            this.activeProduct.gallery = [
                ...this.activeProduct.gallery,
                {
                    id: e.id,
                    sort: null,
                    url: `https://directus.prodelec.app/assets/${e.id}`,
                    origin: 'directus-update',
                    file: null,
                },
            ];
        }
    }

    onOpenFilesModal() {
        setTimeout(() => {
            this.$bvModal.show('show-files-modal');
        }, 400);
    }

    onSetRelation(rel: string, $event: any) {
        this.activeProduct[rel] = $event.target.value;
    }

    onAddProperty() {
        this.activeProduct.properties.push({
            id: uuidv4(),
            name: '',
            is_selector: false,
            value: '',
        });
    }

    onSetProperty(product){
        if(product.properties.length > 0){
            product.properties.forEach(property => {
                this.activeProduct.properties.push(
                    {
                        id: uuidv4(),
                        product_id: product.id,
                        is_selector: false,
                        name: property.name,
                        value: property.value
                    }
                );
            });
        }
    }

    removePropertiesFromActiveProduct(product) {
        if (!this.activeProduct.properties) return;
            this.activeProduct.properties = this.activeProduct.properties.filter(
                (property) => property.product_id !== product.id
            );
        }

    onRemoveProperty(index) {
        this.activeProduct.properties.splice(index, 1);
    }

    mounted() {}
}
